module.exports = __webpack_public_path__ + "static/media/accelerate.0be89f2a.svg";